<template>
  <v-dialog
    v-model="refLinkDialog"
    width="500"
    :transition="false"
    persistent
  >
    <v-card>
      <v-card-title
        class="header info"
        primary-title
      >
        <b>{{ $t('aff.refLinkRankingsTitle') }}</b>
      </v-card-title>
      <v-card-text v-if="rankings">
        <div class="mt-5">
          {{ $t('aff.refLinkRankings') }}
        </div>
        <v-select
          v-model.trim="rankingId"
          class="mt-6"
          :items="rankings.data"
          :item-text="'project.name'"
          :item-value="'id'"
          :label="$t('aff.chooseTraderBot')"
          name="rankingId"
          dense
        />
        <v-text-field
          v-if="rankingId"
          name="link"
          :label="$t('aff.yourLinkRating')"
          :value="affLinkRating"
          readonly
          @focus="$event.target.select()"
        >
          <template v-slot:append>
            <v-icon
              v-clipboard:copy="affLinkRating"
              style="cursor:pointer;"
            >
              mdi-content-copy
            </v-icon>
          </template>
        </v-text-field>
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="$apollo.loading"
          @click="refLinkDialog = false"
        >
          {{ $t('globals.closeButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import REFLINK_RANKINGS_QUERY from "@/graphql/queries/ReflinkRankings.gql";

export default {
  name: "RefLinkDialog",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    refid: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      params: {
        page: 1,
        count: 100
      },
      rankingId: null,
    };
  },
  computed: {
     refLinkDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit('closeRefDialog', val);
      }
    },
    affLinkRating() {
      return location.origin + "/ranking/" + this.rankingId + "?a=" + this.refid;
    },
  },
  apollo: {
    rankings: {
      query: REFLINK_RANKINGS_QUERY,
      variables() {
        return this.params
      }
    }
  }
};
</script>

<style lang="scss" >
</style>
